"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CursorMarqueeIcon = function CursorMarqueeIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M2 7H0V5h2zm0 2H0v2h2zm12-2h2V5h-2zM0 0v3h2V2h1V0zm5 2h2V0H5zm6-2H9v2h2zm2 0v2h1v1h2V0zM2 13H0v3h3v-2H2zm3 3h2v-2H5zm9-6.765l2 1.526V9h-2zm-4-1.794v7.813l1.588-2.387L13.17 16l1.791-.9-1.543-3.08H16z"
    }) : _react["default"].createElement("path", {
      d: "M1 4H0V3h1zm9-4H9v1h1zM1 7H0v1h1zm0-2H0v1h1zm12-2h-1v1h1zm-1 4.455l.714.545H13V7h-1zM1 9H0v1h1zm12-4h-1v1h1zm-1-3h1V0h-2v1h1zM5 13h1v-1H5zM5 1h1V0H5zm2 12h1v-1H7zM7 1h1V0H7zM1 11H0v2h2v-1H1zM0 2h1V1h1V0H0zm3-1h1V0H3zm0 12h1v-1H3zm10.417-1.335l1.544 3.08-1.791.901-1.582-3.132L10 14.9V7.087l6 4.578zm-.376-.9L11 9.209v2.483z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M2 9H0V6h2zm0 2H0v3h2zm9.222-9H14V0h-2.778zM8.89 0H6v2h2.889zM20 6h-2v3h2zm-9 14h3v-2h-3zm-5 0h3v-2H6zm12-8.232l2 1.486V11h-2zM24 18l-9-6.538v11.103l2.382-3.264L19.755 24l2.686-1.351L20.126 18zM0 0v4h2V2h2V0zm2 16H0v4h4v-2H2zM18 4h2V0h-4v2h2z"
    }) : _react["default"].createElement("path", {
      d: "M2 19v1H0v-2h1v1zM1 3H0v2h1zm0 3H0v2h1zm0 6H0v2h1zm0 3H0v2h1zm0-6H0v2h1zm0-8h1V0H0v2h1zm16 0V0h-2v1zm-6 0V0H9v1zm3 0V0h-2v1zM8 1V0H6v1zM5 1V0H3v1zm4 18v1h2v-1zm10-8h1V9h-1zm0-3h1V6h-1zm0-3h1V3h-1zM3 19v1h2v-1zM18 0v1h1v1h1V0zm-6 19v1h2v-1zm-6 0v1h2v-1zm14-5.746V12h-1v.527zM19.755 24l2.686-1.351L20.126 18H24l-9-6.538v11.103l2.382-3.264zm-2.217-6.61L16 19.499v-6.073L20.922 17h-2.41l2.59 5.203-.905.455z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M22 4h-3V2h3zM4 8H2v3h2zm22 3h2V8h-2zm0-5h2V2h-4v2h2zm0 10h2v-3h-2zM4 13H2v3h2zm4 15h3v-2H8zm5 0h3v-2h-3zM9 4h3V2H9zm5 0h3V2h-3zM4 24H2v4h4v-2H4zm0-6H2v3h2zM2 6h2V4h2V2H2zm24.34 25.926l3.582-1.802-3.087-6.16H32l-12-8.756v14.805l3.176-4.353z"
  }) : _react["default"].createElement("path", {
    d: "M24 2h-2V1h2zm-3-1h-2v1h2zm-5 1h2V1h-2zM2 10H1v2h1zm0-6H1v2h1zm0 3H1v2h1zm24 11h1v-2h-1zm1-14h-1v2h1zm0 3h-1v2h1zm0 3h-1v2h1zm-1-7h1V1h-2v1h1zm1 10h-1v2h1zM2 13H1v2h1zm8-11h2V1h-2zM7 27h2v-1H7zm6 0h2v-1h-2zM7 2h2V1H7zm3 25h2v-1h-2zm3-25h2V1h-2zm3 25h2v-1h-2zM2 22H1v2h1zm0-6H1v2h1zM4 2h2V1H4zM2 25H1v2h2v-1H2zm0-6H1v2h1zM1 3h1V2h1V1H1zm3 24h2v-1H4zm21.835-4.036l3.087 6.16-3.582 1.802-3.164-6.266L19 29.013V14.208l12 8.756zm-1.62-1h3.718L20 16.176v9.77l2.332-3.196 3.45 6.834 1.799-.904z"
  }));
};

var _default = CursorMarqueeIcon;
exports["default"] = _default;